'use strict';
/**
 * @author Maxim Seredkin
 */
export default['$rootScope', '$scope', 'RoleRestService',
    function ($rootScope, $scope, RoleRestService) {

        $scope.setFilter = setFilter;
        $scope.selectAll = selectAll;
        $scope.setRoleFilter = setRoleFilter;

        // инициализация
        init();

        // region Function

        function init() {
            $rootScope.title = "Пользователи";

            $scope.filter = {
                all: true,
                enabled: true,
                disabled: true,
                deleted: true,
                role: {authority: null, displayName: "<Все>"}
            };

            RoleRestService.get(null, (data) => {
                $scope.roles = [{authority: null, displayName: "<Все>"}].concat(data._embedded);
            });

            _update();
        }

        function _update() {
            $scope.filters = [];

            if ($scope.filter.enabled) {
                $scope.filters.push("EXTRA:'status' EQ 'ENABLED'");
            }
            if ($scope.filter.disabled) {
                $scope.filters.push("EXTRA:'status' EQ 'DISABLED'");
            }
            if ($scope.filter.deleted) {
                $scope.filters.push("EXTRA:'status' EQ 'DELETED'");
            }

            if ($scope.filter.role != null && $scope.filter.role.authority != null) {
                $scope.filters.push("EXTRA:'authority' EQ '" + $scope.filter.role.authority + "'");
            }
        }

        function setFilter() {
            $scope.filter.all = ($scope.filter.enabled && $scope.filter.disabled && $scope.filter.deleted);
            _update();
        }

        function selectAll() {
            $scope.filter.enabled = true;
            $scope.filter.disabled = true;
            $scope.filter.deleted = true;
            _update();
        }

        function setRoleFilter() {
            _update();
        }

        // endregion
    }]